module.exports = __webpack_public_path__ + "img/Watchlist-new.a6697226.svg";